import React from "react";
import "../css/media-query.css";

function About() {
  return (
    <>

      <div className="contact-container">
        <h2>Contact Us</h2>

        <p><strong>Address:</strong><br/>
        தமிழக வெற்றி கழகம் பேரூர் அலுவலகம்,<br/>
        திற்பரப்பு,<br/>
        திருவட்டார் வடக்கு ஒன்றியம்,<br/>
        குமரி மத்திய மாவட்டம்,<br/>
        தமிழ்நாடு, இந்தியா</p>

                <p><strong>பேரூர் செயலாளர்</strong> : சுபாஷ் : 9092544162<br/>
                <strong>பேரூர் இணை செயலாளர்</strong> : ரெபின்சிஸ் : 9659178100<br/>
                <strong>பேரூர் பொருளாளர்</strong>: கிறிஸ்டின் ராஜ் : 8606262616</p>

        <p><strong>Email:</strong><br/>
        tvk.thirparappu.official@gmail.com</p>

        <p><strong>Office Hours:</strong><br/>
        24 Hours</p>
      </div>

    </>
  );
}

export default About;
